import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL, categories } from '@/data/categories';
import ScrollLink from '@/components/feature/ScrollLink';

export default function Footer() {
  const { t } = useTranslation();
  const { lang = 'en' } = useParams();

  return (
    <footer className="bg-primary-950 text-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50 text-primary-700">
                <i className="ri-table-line text-lg" />
              </span>
              <span className="font-heading font-bold text-lg">{t('logo.name')}</span>
            </div>
            <p className="text-sm text-background-50/80 max-w-md leading-relaxed">
              {t('footer.tagline')}
            </p>
            <p className="text-xs text-background-50/60 max-w-md leading-relaxed mt-4">
              {t('footer.disclaimer')}
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-wide text-background-50/70 mb-4">
              {t('footer.navTitle')}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to={`/${lang}`} className="text-sm text-background-50/85 hover:text-background-50 transition-colors cursor-pointer">
                  {t('nav.spreadsheet')}
                </Link>
              </li>
              <li>
                <ScrollLink to="categories" className="text-sm text-background-50/85 hover:text-background-50 transition-colors cursor-pointer">
                  {t('nav.products')}
                </ScrollLink>
              </li>
              <li>
                <ScrollLink to="topics" className="text-sm text-background-50/85 hover:text-background-50 transition-colors cursor-pointer">
                  {t('nav.guides')}
                </ScrollLink>
              </li>
              <li>
                <ScrollLink to="faq" className="text-sm text-background-50/85 hover:text-background-50 transition-colors cursor-pointer">
                  {t('nav.safety')}
                </ScrollLink>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-wide text-background-50/70 mb-4">
              {t('footer.resourceTitle')}
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((c) => (
                <li key={c.key}>
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/85 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {t(c.key)}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-accent-400 hover:text-accent-300 transition-colors cursor-pointer font-medium"
                >
                  {t('article.ctaButton')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/60">
            © {new Date().getFullYear()} {t('logo.name')}. {t('footer.copyright')}
          </p>
          <p className="text-xs text-background-50/50">{t('footer.disclaimer')}</p>
        </div>
      </div>
    </footer>
  );
}